<template>
  <div class="ch-box">
    <div class="ch-me-info-box">
      <div class="ch-me-info-item">
        <div class="ch-me-info-item-lable">企业名称：</div>
        <div class="ch-me-info-item-value">{{ userInfo.companyName }}</div>
      </div>
      <div class="ch-me-info-item">
        <div class="ch-me-info-item-lable">统一社会信用代码：</div>
        <div class="ch-me-info-item-value">
          {{ userInfo.creditCode }}
          <el-button type="text" @click="openDialog('info')">更换</el-button>
        </div>
      </div>
      <div class="ch-me-info-item">
        <div class="ch-me-info-item-lable">责任人：</div>
        <div class="ch-me-info-item-value">{{ userInfo.userName }}</div>
      </div>
      <div class="ch-me-info-item">
        <div class="ch-me-info-item-lable">手机号：</div>
        <div class="ch-me-info-item-value">
          <span>{{ userInfo.phone }}</span>
          <el-button type="text" @click="openDialog('phone')">更换</el-button>
        </div>
      </div>
      <div class="ch-me-info-item">
        <div class="ch-me-info-item-lable">登录密码：</div>
        <div class="ch-me-info-item-value">
          <span>******</span>
          <el-button type="text" @click="openDialog('pass')">修改</el-button>
        </div>
      </div>
      <div v-if="false" class="ch-me-info-item">
        <div class="ch-me-info-item-lable">是否绑定CA：</div>
        <div class="ch-me-info-item-value">
          <span>{{ userInfo.ifLock ? '是' : '否' }}</span>
          <el-button type="text" @click="lockCa" v-if="!userInfo.ifLock">绑定CA</el-button>
        </div>
      </div>

      <div v-if="false" class="ch-me-info-item">
        <div class="ch-me-info-item-lable">是否会员：</div>
        <div class="ch-me-info-item-value">
          <span>{{ userInfo.memberStatus == 0 ? '否' : userInfo.memberStatus == 1 ? "是" : "过期" }}</span>
          <el-button type="text" @click="memberBuy" v-if="userInfo.memberStatus != 0">续费</el-button>
          <el-button type="text" @click="memberBuy" v-else>购买</el-button>
        </div>
      </div>
    </div>
    <div class="ch-agr-agree">
      <!--      <el-button type="primary" class="el-button">更新信息</el-button>-->
    </div>

    <el-dialog title="修改" center :visible.sync="dialogFormVisible">
      <div class="ch-agr-content">
        <el-form ref="form" :model="passform" class="form" label-width="140px"  :rules="rules">
          <div v-if="val === 'pass'">
            <el-form-item label="旧密码：" prop="oldPassword">
              <el-input v-model="passform.oldPassword" show-password clearable maxlength="20" minlength="8"></el-input>
            </el-form-item>
            <el-form-item label="新密码：" prop="password">
              <el-input v-model="passform.password" show-password clearable maxlength="20" minlength="8"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码：" prop="confirmPass">
              <el-input v-model="passform.confirmPass" show-password clearable maxlength="20" minlength="8"></el-input>
            </el-form-item>
          </div>
          <div v-if="val === 'phone'">
            <el-form-item label="新手机号:" prop="phone">
              <el-input v-model="passform.phone"></el-input>
            </el-form-item>
            <el-form-item label="短信验证码：" prop="verifyCode">
              <el-col :span="11">
                <el-input v-model="passform.verifyCode"></el-input>
              </el-col>
              <el-col :span="11">
                <el-button :disabled="vCodeTimer<30" style="margin-left:10px;" type="success" plain @click="getVCode">{{vCodeStr}}</el-button>
              </el-col>
            </el-form-item>
            <el-form-item label="原登录密码：" prop="password">
              <el-input v-model="passform.password" show-password clearable maxlength="20" minlength="8"></el-input>
            </el-form-item>
          </div>

          <div v-if="val==='info'">
            <el-form-item label="企业名称:" prop="companyName">
              <el-input v-model="passform.companyName"></el-input>
            </el-form-item>

            <el-form-item label="统一社会信用代码:" prop="creditCode">
              <el-input v-model="passform.creditCode"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="updata" size="mini">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import login from "@/api/login/login"
import register from "@/api/register/register"
export default {
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    // console.log(this.userInfo,'this.userInfo1111111');
  }
  ,
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('此项不能为空'));
      } else if (value !== this.passform.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    }
    return {
      vCodeStr:'获取验证码',
      vCodeTimer:30,
      timeoutIndex:'',
      userInfo: null,
      dialogFormVisible: false,
      formLabelWidth: 120,
      passform: {
        phone: null,
        verifyCode: null,
        supplierId: null,
        password:null,
        companyName:null,
        creditCode:null

      },
      val: null,
      phoneForm: {
        phone: null,
        verifyCode: null,
        supplierId: null,
        password:null
      },
      timer: null,
      rules:{
        confirmPass: [
          { required: true, trigger: 'blur' , message: '此项不能为空',},
          { validator: validatePass2, required: true, trigger: 'blur' },
        ],
        oldPassword:[
          { required: true, trigger: 'blur' , message: '此项不能为空',},
        ],
        phone:[
          { required: true, trigger: 'blur' , message: '此项不能为空',},
        ],
        verifyCode:[
          { required: true, trigger: 'blur' , message: '此项不能为空',},
        ],
        password: [
          { required: true, trigger: 'blur' , message: '此项不能为空',},
          { min: 8, max: 20, message: '密码长度需在 8到 20 位之间', trigger: 'blur' },
          { pattern:/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\.]{8,20}$/, message: '密码需同时包含字母大小写、数字、特殊字符！且密码长度需在 8到 20 位之间', trigger: 'change' },
          // { min: 8, max: 20, message: '密码长度需在 8到 20 位之间', trigger: 'blur' }
        ],
        companyName:[
          { required: true, trigger: 'blur' , message: '此项不能为空',},
        ],
        creditCode:[
          { required: true, trigger: 'blur' , message: '此项不能为空',},
        ]
      },
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {

    memberBuy() {
      this.$router.push({
        path: "/bannerNews",
        query: {
          activeName: 7,
        }
      })
    },
    // 绑定ca
    lockCa() {
      clearInterval(this.timer);
      let count = 1
      this.timer = setInterval(() => {
        count--;
        this.$CA.topEsaInit("both");
        if (count <= 0) {
          clearInterval(this.timer)
          if (!this.$CA.getSignCertInfo()) {
            this.$message.warning("未安装数字证书，或未找到符合License的数字证书");
            return
          }
          let serialNumber = this.$CA.getSignCertInfo();
          login.lockCa({
            caSerialNumber: serialNumber,
          }).then(res => {
            if (res.code == 0) {
              this.userInfo.ifLock = true;
              localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
              this.$router.go(0)
              this.$message.success(res.message);
            } else {
              console.log('res', res);
              // this.$message.error(res);
            }
          })
        }
      }, 1000);
    },

    // 获取用户信息
    getUserInfo() {
      login.getUserInfo().then(res => {
        if (res.code == 0) {
          localStorage.setItem("userInfo", JSON.stringify(res.data));
          // this.$message.success(res.message);
        } else {
          console.log('res', res);
          // this.$message.error(res);
        }
      })
    },
    getVCode() {
      // if (this.passform.phone !== undefined) {
      //   register.getVCode({
      //     phone: this.form.phone
      //   }).then(
      //     res => {
      //       console.log(res,'getVCoderes');
      //     }
      //   )
      // } else {
      //   this.$message.warning("手机号不能为空")
      // }
      
      if (this.passform.phone) {
        // dataBody.phone = this.phoneForm.phone
        register.getVCode(
          // phone: this.phoneForm.phone
           this.passform.phone
        ).then(res => {
            if(res.code==500){
              this.$message.error(res.message)
            }else{
              this.$message.success(res.message)
              
              this.timeoutFuc()
            }
          }
        )
      } else {
        this.$message.warning("手机号不能为空")
      }
    },
    timeoutFuc(){
      
      this.timeoutIndex= setInterval(()=>{
        if(this.vCodeTimer<=1){
          this.vCodeStr="获取验证码"
          this.vCodeTimer=30
          clearInterval(this.timeoutIndex)
          this.timeoutIndex=null
          return
        }else{
          this.vCodeTimer=this.vCodeTimer-1
          this.vCodeStr=this.vCodeTimer+"S"
        }
      },1000)
      
    },
    openDialog(val) {
      if(this.$refs['form']){
        this.$refs['form'].resetFields();
      }
      
      this.dialogFormVisible = true;
      if (val === 'pass') {
        this.val = 'pass'
        this.passform.updateType =   1
      } else if(val=='phone') {
        this.val = 'phone'
        this.passform.updateType =   2
      }else{
        this.val = 'info'
        this.passform.updateType =   3
        this.passform.companyName=this.userInfo.companyName
        this.passform.creditCode=this.userInfo.creditCode
      }
    },

    updata() {
      this.$refs["form"].validate((valid) => {
        if(!valid){
          return
        }
        let dataBody = {

        }
        // 修改密码
        if (this.val === 'pass') {
          // dataBody.password = this.passform.password
          // 编辑完成后
        login.editSupplier(this.passform).then(
          res => {
            if (res.code == 0 && this.passform.password && this.passform.confirmPass) {
              this.passform = {
                
              };
              localStorage.removeItem("userInfo");
              this.$message.success(res.message);
              this.$router.replace('/login');
              // console.log(this.userInfo,'this.userInfo');
              this.dialogFormVisible = false;
              // this.$message.success("成功修改密码");
            }
            else{
              this.$message.error(res.message);
            }
          }
        )
        }
        // 更换手机号
        if (this.val == 'phone' || this.val == 'info') {
          if(this.val === 'phone'){
            dataBody.password = this.passform.password
            dataBody.phone = this.passform.phone
            dataBody.updateType=2
            // 验证码
            dataBody.smsCode = this.passform.verifyCode
          }

          if(this.val == 'info'){
            dataBody.creditCode = this.passform.creditCode
            dataBody.companyName = this.passform.companyName
            dataBody.updateType=3
          }
          login.editSupplier(dataBody).then(res => {
            if (res.code == 0) {
              // this.phoneForm = {

              // };
              // localStorage.setItem("userInfo", JSON.stringify(res.data));
              if(this.passform.phone){
                localStorage.removeItem("userInfo");
              }
              
              this.dialogFormVisible = false;
              this.$message.success(res.message);
              this.$router.replace('/login');
            }else{
            this.$message.error(res.message);
            // this.dialogFormVisible = false;
            }
          }
        )}

      })
     
    }
  }
}

</script>

<style lang="less" scoped>
.ch-box {
  padding: 50px;
}

.ch-me-info-box {
  width: 540px;
  padding: 50px 20px;
  box-sizing: border-box;
  margin: auto;
  background-color: #f9f9f9;
  border: 1px solid #efefef;
}

.ch-me-info-item {
  display: flex;
  align-items: center;

  .ch-me-info-item-lable {
    width: 40%;
    text-align: right;
    font-size: 16px;
    color: #333333;
    line-height: 40px;
  }

  .ch-me-info-item-value {
    width: 60%;
    font-size: 16px;
    color: #333333;
  }
}

.ch-me-info-item+.ch-me-info-item {
  margin-top: 5px;
}

.ch-agr-agree {
  margin-top: 50px;
  text-align: center;

  .el-button {
    padding-left: 40px;
    padding-right: 40px;
  }
}

.ch-agr-content-box {
  margin-top: 35px;
  padding: 31px 0;

  >.ch-agr-content {
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    padding: 0 31px;
    width: 400px;
    margin: auto;
  }

  >.ch-agr-content::-webkit-scrollbar-thumb {
    background-color: #efefef;
  }
}
</style>